export default __webpack_public_path__ + "static/media/icon_privacy_overview_step3.805cd1ea.svg";